interface BankMovementDifferenceCellDelegate
{
    differenceCellDidTapAdd(cell:BankMovementDifferenceCell, entry:BankEntry, remainingAmount:number): void;
}

// Shown after the link rows when the linked amounts don't cover the movement:
// the pending difference with the add button to allocate it to a concept
class BankMovementDifferenceCell extends UITableViewCell
{
    delegate:BankMovementDifferenceCellDelegate = null;

    private amountLabel:MUILabel = null;
    private addButton:MUIButton = null;

    private _entry:BankEntry = null;
    private _remainingAmount = 0;

    awakeFromHTML() {
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, function(this:BankMovementDifferenceCell){
            if (this.delegate != null && this._entry != null) {
                this.delegate.differenceCellDidTapAdd(this, this._entry, this._remainingAmount);
            }
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setItem(entry:BankEntry, remainingAmount:number) {
        this._entry = entry;
        this._remainingAmount = remainingAmount;

        let cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter as MIONumberFormatter;
        this.amountLabel.text = cf.stringFromNumber(remainingAmount);
    }
}
